












































































import { Component, Vue, Prop } from 'vue-property-decorator'
import FormDialog from '@/components/dialog/formDialog.vue'
import { enLookupType, enFirstType } from '@/configs/enums'
import { DDLItem, DefDDLItem, getLookupByType, getHeritageLevel, getCitysByUser } from '@/api/common/select'
import { copyArray, copyObject, getDDLItem, getDDLName, getSubDDL } from '@/configs/functions'
import { CruisePlanUnitData, CruisePlanUnitSearchData, getPositionsByUnits } from '@/api/cruisePlan/index'

@Component({
  components: {
    FormDialog
  }
})
export default class CruisePlanSelectUnits extends Vue {
  public name = "CruisePlanSelectUnits"

  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void

  public showDialog: boolean = false
  public loading: boolean = false

  public firstType: number = enFirstType.All
  public defItem: DDLItem = DefDDLItem(this.firstType)
  public levelList: DDLItem[] = []
  public cityList: DDLItem[] = []
  public countyList: DDLItem[] = [this.defItem]

  //文保单位列表
  public unitList: any[] = []

  public emptyForm: CruisePlanUnitData = {
    Id: 0,
    CruisePlanId: 0,
    //1.文保单位 2.单位级别 3.行政区域  4.级别&行政区域
    ObjectType: 0,
    LevelId: 0,
    CityId: 0,
    CountyId: 0,
    UnitId: 0,

    LevelName: '',
    CityName: '',
    CountyName: '',
    UnitName: '',
    PointList: []
  }
  public form: CruisePlanUnitData = Object.assign({}, this.emptyForm)

  public mounted() {
    window.eventBus.$on("openCruisePlanSelectUnits", () => {
      this.form = Object.assign({}, this.emptyForm)
      this.open()
    })
    window.eventBus.$on('submitCruisePlanSearchUnits', (data: CruisePlanUnitSearchData[]) => {
      this.getUnit(data)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("openCruisePlanSelectUnits")
    window.eventBus.$off('submitCruisePlanSearchUnits')
  }
  public open() {
    this.showDialog = true
    this.unitList = []
    this.fetchSource()
  }
  public fetchSource() {
    var f = this.form
    this.showDialog = true
    if (this.levelList.length == 0) {
      getHeritageLevel(this.firstType).then(
        (response: { data: any }) => {
          const data = response.data
          if (data) {
            this.levelList = data
          }
        }
      )
    }
    if (this.cityList.length == 0) {
      getCitysByUser(this.firstType).then(
        (response: { data: any }) => {
          const data = response.data
          if (data) {
            if (data.length == 2) {
              data.splice(0, 1)
            }
            this.cityList = data
            this.setAreaId()
          }
        }
      )
    }
    this.setAreaId()
  }
  public setAreaId() {
    var f = this.form
    if (f.CityId == 0 && this.cityList.length == 1) {
      f.CityId = this.cityList[0].Key
    }
    if (f.CityId > 0) {
      this.countyList = getSubDDL(this.cityList, f.CityId)
      if (this.countyList.length == 2) {
        this.countyList.splice(0, 1)
      }
      if (this.countyList.length == 1) {
        f.CountyId = this.countyList[0].Key
      }
    }
  }
  public resetUnit() {
    var f = this.form
    f.UnitId = 0
    f.UnitName = ''
    f.PointList = []
    this.unitList = []
  }
  public levelChange() {
    this.resetUnit()
  }
  public cityChange() {
    var f = this.form
    f.CountyId = 0
    this.countyList = [this.defItem]
    if (f.CityId > 0) {
      this.countyList = getSubDDL(this.cityList, f.CityId)
      if (this.countyList.length == 1) {
        f.CountyId = this.countyList[0].Key
      }
    }
    this.resetUnit()
  }
  public close() {
    this.showDialog = false
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public openUnitSearch() {
    var f = this.form
    var levelName = f.LevelId > 0 ? getDDLName(this.levelList, f.LevelId) : ''
    var cityName = f.CityId > 0 ? getDDLName(this.cityList, f.CityId) : ''
    var countyName = f.CountyId > 0 ? getDDLName(this.countyList, f.CountyId) : ''
    var info = {
      LevelId: f.LevelId,
      CityId: f.CityId,
      CountyId: f.CountyId,
      LevelName: levelName,
      CityName: cityName,
      CountyName: countyName,
      MultiSelect: true
    }
    window.eventBus.$emit('openCruisePlanSearchUnits', info)
  }
  public getUnit(data: CruisePlanUnitSearchData[]) {
    var curUnits = this.unitList.map((e: CruisePlanUnitSearchData) => {
      return e.UnitId
    })
    var unitIds: number[] = []
    data.forEach((e: CruisePlanUnitSearchData) => {
      if (curUnits.findIndex(v => v == e.UnitId) == -1) {
        let u = copyObject(e)
        u.PointIds = []
        u.PointList = []
        this.unitList.push(u)
        unitIds.push(e.UnitId)
      }
    })
    if (unitIds.length > 0) {
      this.fetchPoints(unitIds)
    }
  }
  public fetchPoints(unitIds: number[]) {
    this.loading = true
    getPositionsByUnits(unitIds).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        unitIds.forEach((e: any) => {
          var unit = this.unitList.find((v: any) => v.UnitId == e)
          if (unit) {
            unit.PointList = data.filter((v: any) => v.UnitId == e)
          }
        })
        this.loading = false
      }
    })
  }
  public delUnit(index: number) {
    this.unitList.splice(index, 1)
  }
  public sendData(data: any) {
    window.eventBus.$emit("submitCruisePlanSelectUnits", data)
  }
  // 确定事件
  public onSubmit() {
    let f = this.form
    if (f.LevelId == 0 && f.CityId == 0 && this.unitList.length == 0) {
      this.$message({
        type: 'warning',
        message: '单位级别，所在市县和文保单位必须选一项'
      })
      return
    }
    let hasUnits = false
    /// 巡查对象类型：1.文保单位 2.单位级别 3.行政区域  4.级别&行政区域
    /// 判断依据
    /// 1.文保单位 UnitId>0
    /// 2.单位级别 UnitId=0 && CityId=0 && LevelId>0
    /// 3.行政区域 UnitId=0 && LevelId=0 && CityId>0
    /// 4.级别&行政区域 UnitId=0 && CityId>0 && LevelId>0
    /// 也就页面展示用，对生成任务的判断没啥意义
    // f.ObjectType = f.UnitId>0?1
    if (this.unitList.length > 0) {
      f.ObjectType = 1
      hasUnits = true
    }
    else {
      if (f.LevelId > 0 && f.CityId == 0) {
        f.ObjectType = 2
      }
      if (f.CityId > 0 && f.LevelId == 0) {
        f.ObjectType = 3
      }
      if (f.CityId > 0 && f.LevelId > 0) {
        f.ObjectType = 4
      }
    }
    if (f.LevelId > 0 && f.LevelName == '') {
      f.LevelName = getDDLName(this.levelList, f.LevelId)
    }
    if (f.CityId > 0 && f.CityName == '') {
      f.CityName = getDDLName(this.cityList, f.CityId)
    }
    if (f.CountyId > 0 && f.CountyName == '') {
      f.CountyName = getDDLName(this.countyList, f.CountyId)
    }
    f.PointList = []
    let data: CruisePlanUnitData[] = []
    if (hasUnits) {
      this.unitList.forEach((v: any) => {
        let d = copyObject(f)
        d.LevelId = v.LevelId
        d.LevelName = v.LevelName
        d.CityId = v.CityId
        d.CityName = v.CityName
        d.CountyId = v.CountyId
        d.CountyName = v.CountyName
        d.UnitId = v.UnitId
        d.UnitName = v.UnitName

        if (v.PointIds.length > 0) {
          v.PointIds.forEach((e: number) => {
            var p = v.PointList.find((v: any) => v.Id == e)
            if (p) {
              d.PointList.push({
                Id: 0,
                CruisePlanUnitId: f.Id,
                UnitId: d.UnitId,
                PointId: p.Id,
                PointName: p.PositionName
              })
            }
          })
        }
        data.push(d)
      })
    }
    else {
      data.push(f)
    }
    //回传给父组件
    this.sendData(data)
    this.showDialog = false
  }
}
